import { useEffect, useState } from "react";
import Head from "next/head";
import Layout from "layout/Layout/index.js";
import Image from "next/image";
import SSS from "components/SSS/SSS";
import SSLTable from "@/components/SSLCertificates/SSLTable";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import {
  addProductBasketSSL,
  checkAddBasket,
  getCurrencyRates,
  getProjectList,
  getSSLCertificate
} from "services/allServices";
import { changeCurrency } from "helpers/helpersFunc";
import { useAuthStore } from "store/AuthStore";
import SSLSelectProjectModal from "components/SSLCertificates/SSLSelectProjectModal";
import { useTranslation } from "next-i18next";
import { useRouter } from "next/router";
import { useGlobalStore } from "store/GlobalStore";
import SSSData from "public/SSS/sss-tr-ssl-sertifikası.json";
import SSSDataEN from "public/SSS/sss-en-ssl-sertifikası.json";
import { googleEventAddBasketSSL } from "helpers/googleEvents";

function sslcertificates({ datas, rates }) {
  const [isLoggin, setIsLoggin, setLogginOpen] = useAuthStore(((state) => [state.isLoggin, state.setIsLoggin, state.setLogginOpen]));
  const { t } = useTranslation(["common"]);
  const router = useRouter();
  const [currencyType, currencyRates, setCurrencyRates] = useGlobalStore((state) => [state.currencyType, state.currencyRates, state.setCurrencyRates]);

  const [sslList, setsslList] = useState();
  const [allData, setAllData] = useState();
  const [selectedTab, setSelectedTab] = useState(0);
  const [selectedTabData, setSelectedTabData] = useState();
  const [openModal, setOpenModal] = useState(false);
  const [selectedProject, setSelectedProject] = useState();
  const [projectList, setProjectList] = useState();
  const [projectNameList, setProjectNameList] = useState();

  const onListSSLCertificate = async () => {
    setAllData(datas);
    let newList = [];
    await datas.map(async (item) => {

      item?.available_components?.sort((a, b) => a.price.one_year - b.price.one_year).map(ssl => {
        newList.push({ ...ssl, product_id: item.id });
      });
    });
    setsslList(newList);
  };

  const onSetSelectedTab = async (i) => {
    setSelectedTab(i);
    if (i > 0) {
      // let filteredData = allData[i - 1].available_components.content.available_components
      let filteredData = allData.find(x => x.id === i).available_components;
      await setSelectedTabData();
      setSelectedTabData(filteredData);
      // await setSelectedTabData()
      // setSelectedTabData({ ...filteredData, product_id: allData[i - 1].available_components.content.product_id })
    }

  };

  const onAddBasketBefore = async (selectedData) => {
    if (isLoggin) {
      setOpenModal(selectedData);
    } else {
      setLogginOpen(true);
    }

  };

  const onAddBasket = async (selectedData, params) => {
    if (isLoggin) {
      await checkAddBasket().then(async (isAddBasket) => {
        if (isAddBasket.status) {
          let productID = selectedTab !== 0 ? selectedTab : selectedData?.product_id;
          let totalPrice = changeCurrency(currencyRates, currencyType, parseFloat((selectedData.price.one_year * 0.20) + selectedData.price.one_year).toFixed(2));
          let totalPriceWithOutKdv = changeCurrency(currencyRates, currencyType, selectedData.price.one_year, selectedData.currency);
          let basketId = 0;
          let currency = currencyRates.find(x => x.symbol === currencyType)?.currency_type;

          let configureAvailable = {
            component_type_id: 22,
            component_id: selectedData.component_id,
            quantity: 1,
            payment_cycle: 12
          };
          await addProductBasketSSL(productID, 12, selectedProject.id, totalPriceWithOutKdv, "", params?.hostname, configureAvailable, currency).then(data => {
            basketId = data.basket_ssl_product_id;
            googleEventAddBasketSSL(selectedData, totalPriceWithOutKdv, currency, 12, basketId)
          });

          router.push(t("nav:basket"));
        } else {
          alert("Ödenmemiş proformanız vardır. Sepet oluşturamazsınız.");
        }
      });


    } else {
      setLogginOpen(true);
    }

  };

  const onGetProjectList = () => {
    getProjectList().then(data => {
      setProjectList(data);
      let nameList = [];
      data.map(item => {
        nameList.push(item.name);
        if (item.default_project === true) {
          setSelectedProject(item);
        }
      });
      setProjectNameList(nameList);

    }).catch(err => {
      if (err?.request?.status === 401) {
        setIsLoggin(false);
      }
    });
  };
  const onSetSelectedProject = (item) => {
    if (item) {
      projectList.map(prj => {
        if (prj.name === item) {
          setSelectedProject(prj);
        }
      });
    }

  };

  useEffect(() => {
    onListSSLCertificate();

  }, []);


  useEffect(() => {
    if (isLoggin) {
      onGetProjectList();
    }
  }, [isLoggin]);

  useEffect(() => {
    setCurrencyRates(rates);
  }, [rates]);
  return (
    <Layout>
      <Head>
        <title>{t('sslMetaTitle')}</title>
        <meta name="description" content={t('sslMetaDescription')} />
        <meta property="og:title" content={t('sslMetaTitle')} key="title" />
        <meta property="og:description" content={t('sslMetaDescription')} key="description" />
      </Head>
      <div className="w-full bg-no-repeat transform-gpu bg-SSLBg">
        <div className="container px-4 pt-20 pb-20 mx-auto lg:px-0">
          <div className="flex justify-between mb-14">
            <div className="flex-1">
              <p className="text-xl">{t("ssl:title")}</p>
              <h1 className="my-3 text-5xl font-semibold">{t("ssl:title2")}</h1>
              <p>{t("ssl:description")}</p>
            </div>
            <div className="hidden flex-1 justify-end lg:flex">
              <Image
                src="/sslImage.svg"
                alt="ssl"
                title="ssl"
                width="327"
                height="110"
                priority
                loading="eager"
                className="transform-gpu"
              />

            </div>
          </div>

          <div className="overflow-x-auto p-8 mb-20 bg-white rounded-md shadow-lg">
            <div className="flex justify-between items-center mb-6">
              <p className="text-2xl font-medium text-titleColor">{t("ssl:sslCertificate")}</p>
              <div className="flex items-center">
                <div onClick={() => onSetSelectedTab(0)}
                  className={`px-5 py-2  ml-4 rounded-full cursor-pointer border ${selectedTab === 0 ? "bg-makdosYellow border-makdosYellow" : "bg-white border border-makdosSecondaryGray hover:bg-makdosYellow transition-all duration-300"}`}>
                  <p className="font-semibold text-titleColor">{t("ssl:allCertificate")}</p>
                </div>
                {allData &&
                  allData.map((item, index) => {
                    return (
                      <div onClick={() => onSetSelectedTab(item.id)}
                        className={`px-5 py-2  ml-4 rounded-full cursor-pointer border ${selectedTab === item.id ? "bg-makdosYellow border-makdosYellow" : "bg-white border border-makdosSecondaryGray hover:bg-makdosYellow transition-all duration-300"}`}
                        key={index + 1}>
                        <p className="font-semibold text-titleColor">{item.product_name}</p>
                      </div>
                    );
                  })

                }
              </div>
            </div>
            {sslList && selectedTab === 0 &&
              <SSLTable datas={sslList} onAddBasket={(v) => onAddBasketBefore(v)} />

            }

            {selectedTabData && selectedTab !== 0 &&
              <SSLTable datas={selectedTabData} onAddBasket={(v) => onAddBasketBefore(v)} />

            }
            {openModal &&
              <SSLSelectProjectModal type="ssl" setOpenModal={() => setOpenModal(false)}
                onClick={(v, p) => onAddBasket(v, p)} selectedData={openModal}
                selectedProject={selectedProject}
                onSetSelectedProject={(v) => onSetSelectedProject(v)}
                projectNameList={projectNameList} />
            }

          </div>
          <div className="grid grid-cols-2">
            <div className="flex col-span-2 items-center lg:col-span-1">
              {router.locale === "tr" ?
                <Image src="/sslSertifika.png" alt="ssl-certificate" title="ssl-certificate" width="515" height="504" />
                :
                <Image src="/sslSertifikaEN.png" alt="ssl-certificate" title="ssl-certificate" width="515" height="504" />
              }
            </div>
            <div className="col-span-2 pr-16 lg:col-span-1">
              <h2 className="mb-5 text-4xl font-semibold text-titleColor font">{t("ssl:sslParagraphTitle")}</h2>
              <p className="text-sm text-cardText">{t("ssl:sslParagraphDescription1")}</p>
              <br />
              <p className="text-sm text-cardText">{t("ssl:sslParagraphDescription2")}</p>
              <br />
              <p className="text-sm text-cardText">{t("ssl:sslParagraphDescription3")} </p>
              <br />
              <p className="text-xl font-semibold text-titleColor">{t("ssl:thisTypeSSL")}</p>
              <div className="mt-4">
                <div className="flex items-center mb-3">
                  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M9 16.5C4.85775 16.5 1.5 13.1422 1.5 9C1.5 4.85775 4.85775 1.5 9 1.5C13.1422 1.5 16.5 4.85775 16.5 9C16.5 13.1422 13.1422 16.5 9 16.5ZM8.25225 12L13.5547 6.69675L12.4943 5.63625L8.25225 9.879L6.1305 7.75725L5.07 8.81775L8.25225 12Z"
                      fill="#45D85B" />
                  </svg>
                  <p className="ml-2 text-cardText text-md">{t("ssl:sslType1")}</p>
                </div>
                <div className="flex items-center mb-3">
                  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M9 16.5C4.85775 16.5 1.5 13.1422 1.5 9C1.5 4.85775 4.85775 1.5 9 1.5C13.1422 1.5 16.5 4.85775 16.5 9C16.5 13.1422 13.1422 16.5 9 16.5ZM8.25225 12L13.5547 6.69675L12.4943 5.63625L8.25225 9.879L6.1305 7.75725L5.07 8.81775L8.25225 12Z"
                      fill="#45D85B" />
                  </svg>
                  <p className="ml-2 text-cardText text-md">{t("ssl:sslType2")}</p>
                </div>
                <div className="flex items-center mb-3">
                  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M9 16.5C4.85775 16.5 1.5 13.1422 1.5 9C1.5 4.85775 4.85775 1.5 9 1.5C13.1422 1.5 16.5 4.85775 16.5 9C16.5 13.1422 13.1422 16.5 9 16.5ZM8.25225 12L13.5547 6.69675L12.4943 5.63625L8.25225 9.879L6.1305 7.75725L5.07 8.81775L8.25225 12Z"
                      fill="#45D85B" />
                  </svg>
                  <p className="ml-2 text-cardText text-md">{t("ssl:sslType3")}</p>
                </div>
                <div className="flex items-center mb-3">
                  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M9 16.5C4.85775 16.5 1.5 13.1422 1.5 9C1.5 4.85775 4.85775 1.5 9 1.5C13.1422 1.5 16.5 4.85775 16.5 9C16.5 13.1422 13.1422 16.5 9 16.5ZM8.25225 12L13.5547 6.69675L12.4943 5.63625L8.25225 9.879L6.1305 7.75725L5.07 8.81775L8.25225 12Z"
                      fill="#45D85B" />
                  </svg>
                  <p className="ml-2 text-cardText text-md">{t("ssl:sslType4")}</p>
                </div>
                <div className="flex items-center mb-3">
                  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M9 16.5C4.85775 16.5 1.5 13.1422 1.5 9C1.5 4.85775 4.85775 1.5 9 1.5C13.1422 1.5 16.5 4.85775 16.5 9C16.5 13.1422 13.1422 16.5 9 16.5ZM8.25225 12L13.5547 6.69675L12.4943 5.63625L8.25225 9.879L6.1305 7.75725L5.07 8.81775L8.25225 12Z"
                      fill="#45D85B" />
                  </svg>
                  <p className="ml-2 text-cardText text-md">{t("ssl:sslType5")}</p>
                </div>
                <div className="flex items-center mb-3">
                  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M9 16.5C4.85775 16.5 1.5 13.1422 1.5 9C1.5 4.85775 4.85775 1.5 9 1.5C13.1422 1.5 16.5 4.85775 16.5 9C16.5 13.1422 13.1422 16.5 9 16.5ZM8.25225 12L13.5547 6.69675L12.4943 5.63625L8.25225 9.879L6.1305 7.75725L5.07 8.81775L8.25225 12Z"
                      fill="#45D85B" />
                  </svg>
                  <p className="ml-2 text-cardText text-md">{t("ssl:sslType6")}</p>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
      <SSS data={router.locale === "tr" ? SSSData : SSSDataEN} />
    </Layout>
  );
}

export default sslcertificates;

export const getServerSideProps = async ({ locale }) => {
  let datas = {};
  await getSSLCertificate().then(res => {
    datas = res;
  });
  let rates = {};
  await getCurrencyRates().then(res => {
    rates = res;
  });
  return {
    props: {
      ...await serverSideTranslations(locale, ["common", "nav", "ssl"]),
      datas: datas,
      rates: rates
    }
  };
};